
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/annonce/[slug]",
      function () {
        return require("private-next-pages/annonce/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/annonce/[slug]"])
      });
    }
  